import { atom } from 'jotai/vanilla';
import type { ModelingFormat } from 'balus-common';

type AtomValue = {
  modelingFormat: ModelingFormat;
};

export const viewModelModelingFormatAtom = atom<AtomValue>({
  modelingFormat: 'CJK',
});
